import { createContext, useContext, useEffect, useState, useCallback } from "react";

const DisplayContext = createContext(null);
export const useDisplay = () => useContext(DisplayContext);

const gcd = (a, b) => (b ? gcd(b, a % b) : a);

// Convert a 0-100 probability into a friendly "X in Y" chance string.
export function toChance(pct) {
  if (pct == null || isNaN(pct)) return "-";
  const p = Math.max(0, Math.min(100, Number(pct)));
  if (p <= 0) return "0 in 10";
  if (p >= 100) return "10 in 10";
  if (p < 10) return `1 in ${Math.round(100 / p)}`;
  let num = Math.round(p / 10);
  let den = 10;
  const g = gcd(num, den) || 1;
  return `${num / g} in ${den / g}`;
}

export function DisplayProvider({ children }) {
  const [format, setFormat] = useState(() => localStorage.getItem("pl_prob_format") || "chance");

  useEffect(() => {
    localStorage.setItem("pl_prob_format", format);
  }, [format]);

  const toggle = useCallback(() => setFormat((f) => (f === "chance" ? "percent" : "chance")), []);

  // Render a probability (0-100) in the user's chosen format.
  const fmtProb = useCallback(
    (pct) => {
      if (pct == null || isNaN(pct)) return "-";
      return format === "chance" ? toChance(pct) : `${Math.round(pct)}%`;
    },
    [format]
  );

  return (
    <DisplayContext.Provider value={{ format, setFormat, toggle, fmtProb }}>
      {children}
    </DisplayContext.Provider>
  );
}
